import { SpanError } from "../atoms/SpanError";

export const FormInput = ({
  id,
  label,
  type,
  placeholder,
  register,
  min = "0",
  validation = {},
  error,
  onChange,
  className = "",
  classNameInput = "py-3",
  classNameError = "-bottom-4",
}) => (
  <div className={className}>
    <label className="tracking-wide text-slate-700 font-bold uppercase text-sm" htmlFor={id}>
      {label} {validation.required && <span className="absolute text-base text-red-500 font-bold -top-1">*</span>}
    </label>
    <input
      className={`w-full text-black border shadow-sm rounded-lg ${classNameInput} px-4 focus:ring-1 focus:border-blue-500 focus:ring-blue-300 transition-colors hover:border-blue-500 ${error ? "border-red-400" : "border-slate-300"
        }`}
      type={type}
      min={min}
      placeholder={placeholder}
      id={id}
      {...register(id, {
        ...validation,
        onChange: (e) => {
          if (onChange) onChange(e);
        },
      })}
    />
    {error && <SpanError error={error} className={classNameError} />}
  </div>
);
